function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

var _arguments = arguments;

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownMenu, DropdownToggle, NavItem } from 'reactstrap';
import NavIcon from '../elements/NavIcon';
import NavLink from '../elements/NavLink';
export var makeItem = function makeItem(name, icon, link, items, pageKey) {
  if (typeof icon === 'string') {
    var iconParts = icon.split(':');
    var iconProps = {
      name: iconParts[0]
    };

    if (iconParts.length > 1) {
      iconProps.font = iconParts[1];
    }

    return {
      name: name,
      icon: iconProps,
      link: link,
      items: items,
      pageKey: pageKey
    };
  } else {
    return {
      name: name,
      icon: icon,
      link: link,
      items: items,
      pageKey: pageKey
    };
  }
};
export function makeDropdownIcon(icon) {
  var iconParts = icon.split(':');
  return {
    fixedWidth: true,
    font: iconParts[1],
    name: iconParts[0]
  };
} // eslint-disable-next-line no-undef

var lazyFunction = function lazyFunction(f) {
  return function () {
    return f.apply(_arguments);
  };
};

export var itemPropTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    name: PropTypes.string.isRequired,
    font: PropTypes.string,
    fixedWidth: PropTypes.bool
  })]).isRequired,
  name: PropTypes.node.isRequired,
  link: PropTypes.shape({
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
  }),
  items: PropTypes.arrayOf(lazyFunction(function () {
    return itemPropTypes;
  })),
  pageKey: PropTypes.string
};

var Item = /*#__PURE__*/function (_Component) {
  _inherits(Item, _Component);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Item).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.toggle = _this.handleClick;
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(Item, [{
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isActive = _this$props.isActive,
          site = _this$props.site,
          tag = _this$props.tag,
          _this$props$item = _this$props.item,
          icon = _this$props$item.icon,
          link = _this$props$item.link,
          name = _this$props$item.name,
          items = _this$props$item.items,
          passThroughProps = _objectWithoutProperties(_this$props, ["isActive", "site", "tag", "item"]);

      if (items) {
        return /*#__PURE__*/React.createElement(Dropdown, {
          inNavbar: true,
          isOpen: this.state.isOpen,
          nav: true,
          toggle: this.toggle
        }, /*#__PURE__*/React.createElement(DropdownToggle, {
          caret: true,
          className: isActive ? 'selected' : '',
          nav: true
        }, /*#__PURE__*/React.createElement(NavIcon, icon), name), /*#__PURE__*/React.createElement(DropdownMenu, null, items.map(function (item, idx) {
          return /*#__PURE__*/React.createElement(Item, {
            item: item,
            key: idx,
            onClick: _this2.handleClick,
            site: site,
            tag: "div"
          });
        })));
      } else {
        var NavTag = tag;
        return /*#__PURE__*/React.createElement(NavTag, null, link ? /*#__PURE__*/React.createElement(NavLink, _extends({
          active: isActive,
          site: site
        }, link, passThroughProps), /*#__PURE__*/React.createElement(NavIcon, icon), name) : /*#__PURE__*/React.createElement("span", {
          className: "navbar-text"
        }, icon ? /*#__PURE__*/React.createElement(NavIcon, icon) : null, name));
      }
    }
  }]);

  return Item;
}(Component);

_defineProperty(Item, "propTypes", {
  isActive: PropTypes.bool,
  item: PropTypes.shape(itemPropTypes).isRequired,
  site: PropTypes.string.isRequired,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
});

_defineProperty(Item, "defaultProps", {
  tag: NavItem
});

_defineProperty(Item, "makeItem", makeItem);

;
export default Item;